import React from 'react';

const PageContainer = ({ children }) => {
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh',  
            backgroundColor: '#f9f9f9' 
        }}>
            <main style={{ flex: 1 }}>
                {children}
            </main>
        </div>
    );
};

export default PageContainer;